import { render, staticRenderFns } from "./TaskMoneyConfigliulan.vue?vue&type=template&id=20612022&"
import script from "./TaskMoneyConfigliulan.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigliulan.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigliulan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports